module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"notWorkers":"There are no agents connected in this company"},"es":{"notWorkers":"No hay agentes conectados en esta compañia"}}')
  delete Component.options._Ctor
}
